import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { ImportObject, ValidateObject } from '~/front-models/fileToImport';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { SharedService } from '~/services/sharedService';

@Injectable({ providedIn: 'root' })
export class ImportService extends ApiServiceBase {

      importedItem:any;

      savedMapItem:any;
      isMapSaved = new EventEmitter<any>();

    constructor(injector: Injector, private http: HttpClient, private _sharedService: SharedService) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    import(labelName: string, model: ImportObject, isAsset : boolean = false) {
        if(isAsset == true && !this._sharedService.commonModulesHasStockController.includes(labelName)){
            this.setBase(API_NAMES.assets);
        }
        if(labelName == "users" || labelName == "persons")
        {
          this.setBase(API_NAMES.identity);
        }
        if (labelName === 'stockItems') {
            labelName = 'items';
        }
        if (labelName === 'uom') {
          labelName = 'UnitOfMeasures';
      }
      if (labelName === 'fundingsource') {
        labelName = 'fundingSources';
    }
    if (labelName === 'asset-purchaseOrders') {
      labelName = 'assetPurchaseOrders';
  }
  if (labelName === 'persons') {
    labelName = 'users';
  }
      var url = "";
      if(model.importUpsertSetting == "new" || model.importUpsertSetting == "treatAsReceiveTransaction")
      {
          url = this._url(labelName, `/import`);
          if(labelName == 'departments'){
            url = url.replace('stocks','assets')
          }

      }
      else if(model.importUpsertSetting == "update")
      {
          url = this._url(labelName, `/import-update`);
      }
      else if(model.importUpsertSetting == "alternateStockItem")
      {
        url = this._url(labelName, `/import-alternate-stock-update`);
      }
      else if(model.importUpsertSetting == "locationMinMax")
      {
        url = this._url(labelName, `/import-location-min-max-stockitem`);
      }
      else if(model.importUpsertSetting == "assignedAssets")
          {
           url =  this._url(labelName, `/import-AssignAsset`);
          }
          // model.dataToImport.forEach((element: any) => {
          //   if(!element.customFieldsValue)
          //   element.customFieldsValue = [];
          // });
        return this.client.post<any>(url, model);
    }

    validate(labelName: string, model: any, isAsset : boolean = false) {
        if(isAsset == true && !this._sharedService.commonModulesHasStockController.includes(labelName)){
            this.setBase(API_NAMES.assets);
        }
        else
        {
          this.setBase(API_NAMES.stocks);
        }
        if(labelName == "users" || labelName == "persons")
        {
          this.setBase(API_NAMES.identity);

        }
         if (labelName === 'stockItems') {
            labelName = 'items';
        }
        if (labelName === 'uom') {
          labelName = 'UnitOfMeasures';
      }
      if (labelName === 'fundingsource') {
        labelName = 'fundingSources';
    }
    if (labelName === 'asset-purchaseOrders') {
      labelName = 'assetPurchaseOrders';
  }
  if (labelName === 'persons') {
    labelName = 'users';
}
  var url = '';
        if(model.importUpsertSetting == "alternateStockItem")
          {
             url =  this._url(labelName, `/validate-importAlternateStockItem`);

          }
          else if(model.importUpsertSetting == "locationMinMax")
          {
           url =  this._url(labelName, `/validate-importLocationMinMaxStockItem`);

          }
          else if(model.importUpsertSetting == "assignedAssets")
          {
             url =  this._url(labelName, `/validate-importAssignAsset`);

          }
          else
          {
            url = this._url(labelName, `/validate-import`);
            if(labelName == 'departments'){
              url = url.replace('stocks','assets')
            }
          }

          return this.client.post<any>(url, model);
    }

    getImportNames()
    {
      this.setBase(API_NAMES.adminStock);
      let url =  this._url('ImportMapp');
      return this.http.get<any>(url);
    }

    createImportMap(mapObj:any)
    {
      this.setBase(API_NAMES.adminStock);
      let url =  this._url('ImportMapp');
      return this.http.post<any>(url,mapObj);
    }

    deletetMap(Id:number)
    {
      this.setBase(API_NAMES.adminStock);
      let url =  this._url(`ImportMapp/${Id}`);
      return this.http.delete<any>(url);
    }
    edittMap(Id:number,model:any)
    {
      this.setBase(API_NAMES.adminStock);
      let url =  this._url(`ImportMapp/${Id}`);
      return this.http.put<any>(url,model);
    }

    private _url(path: string, v?: string | undefined) {
        v = v || '';
        return this.url(`/${path}${v}`);
    }
}
